export default __webpack_public_path__ + "static/media/26-face-screaming-in-fear_1f631.a7cdacf6.png";